import { envBasics } from 'src/environments/trackline/basics';
import { Environment } from '../../app/environment';

export const environment: Environment = {
    ...envBasics,
    apiEndpoint: 'https://planning-test.trackline.nl/api/',
    disableAfas: true,
    feEndpoint: 'https://planning-test.trackline.nl/',
    orderDirect: true,
    production: true,
    test: true,
    titleAppend: ' - TEST - Track Line B.V.',
    wsEndpoint: 'wss://planning-test.trackline.nl/websocket/',
};
